export default __webpack_public_path__ + "static/media/shape-2.dab9fe6f.png";